enum Color {
  Primary = '#edb900',
  Secondary = '#ea68ff',
  Fill = '#2D4055',
  FillAlpha = 'rgba(45, 64, 85, 0.5)',
  FillSecondary = '#4f299b',
  FillSecondaryAlpha = 'rgba(79, 41, 155, 0.5)',
  Text = '#efefef',
  Placeholder = '#f9f9f9',
  Error = '#c53030',
  Empty = '#0f0f0f',
  Transparent = 'rgba(255,255,255,0.001)',
  WhiteAplha = 'rgba(255,255,255,0.1)',
  WhiteAplhaSelected = 'rgba(255,255,255,0.2)',
  BlackAplha = 'rgba(0,0,0,0.1)',
  BlackAplhaSelected = 'rgba(0,0,0,0.3)',
}

export default Color;
